import { Dialog, SizableText, YStack } from 'tamagui'
import { Button, ButtonProps } from '../button'

export type ConfirmationModalOption = ButtonProps

export interface ConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: () => void
  title: string
  options: ConfirmationModalOption[]
}

export const ConfirmationModal = (props: ConfirmationModalProps) => {
  return (
    <Dialog modal open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Portal p="$3.5" zIndex="$2" h="100%">
        <Dialog.Overlay
          key="overlay"
          animation="quick"
          bg="$backdrop"
          opacity={1}
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />

        <Dialog.Content
          width="100%"
          maxWidth={600}
          borderRadius="$3"
          key="content"
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ opacity: 0, scale: 0.9 }}
          exitStyle={{ opacity: 0, scale: 0.95 }}
          $gtSm={{
            maxHeight: 600,
          }}
        >
          <YStack gap="$5" p="$2">
            <SizableText ta="center" size="$7" fow="600" color="$black">
              {props.title}
            </SizableText>
            <YStack gap="$3">
              {props.options.map((option, i) => (
                <Button key={`Confirmation:${i}`} size="$4" {...option} />
              ))}
            </YStack>
          </YStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
